import React from 'react';
import { language } from '../assets/lang';
import { functions } from './firebase/firebase';
import Warning from '../assets/images/icons/pp_warning.svg';
import Gift from '../assets/images/icons/gift.svg';

class Payment extends React.Component {
    render() {	
        return ( 
        <div style={{height: '100%', width: '100%'}}>
            <div onClick={() => {this.props.changeEventState('', (this.state.process === 1)); this.setState({voucher: '', process: -1})}} style={{marginLeft: 5, marginTop: 10, width: 50, height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <i class="fa fa-chevron-left" style={{color: 'rgba(0,0,0,0.6)'}}></i>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', paddingLeft: 20, paddingRight: 20, marginTop: 20}}>				
                <div style={{width: '100%', borderRadius: 15, overflow: 'hidden'}}>		
                    {this.state.process === -1 ?
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                        <img src={Gift} style={{width: 40, height: 40}} />				
                        <p style={{fontSize: 18, marginTop: 20, color: '#22293b', fontFamily: 'Kentledge'}}>{language.vouchercode}</p>
                        <input type="text" selectionColor={this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d'} style={{width: 270, textAlign: 'center', marginTop: 25, color: '#22293b', height: 50, justifyContent: 'center', paddingHorizontal: 20, borderRadius: 7, backgroundColor: 'rgba(0,0,0,0.04)', fontFamily: 'Kentledge', fontSize: 15, borderWidth: 1, borderColor: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', borderStyle: 'dotted'}} onChange={(e) => this.setState({voucher: e.target.value.replace(/\s+/g, '')})} placeholder={language.vouchercode} placeholderTextColor='rgba(0,0,0,0.2)' />	
                        <div onClick={() => this.processSharecode()} style={{display: 'flex', marginTop: 35, marginBottom: 20, backgroundColor: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', borderRadius: 30,  width: 200, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height:45}}>
                            <p style={{fontSize: 14, color: '#f1f2f4', fontFamily: 'Kentledge', textAlign: 'center',}}>{language.addvoucher}</p>
                        </div>
                    </div>						
                    :null}
                    {this.state.process === 0 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center'}}>				
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%'}}>	
                            <img src={require('../assets/images/indicator.gif')} resizeMode='contain' style={{width: 60, height: 60}}/>			
                            <p style={{fontSize: 16, marginTop: 45, color: '#22293b', fontFamily: 'Kentledge'}}>{language.addvoucher}</p>
                        </div>						
                    </div>
                    :null}
                    {this.state.process === 1 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <div style={{display: 'flex', width: 100, height: 100, borderRadius: 100, borderWidth: 2, borderStyle: 'solid', borderColor: '#669e3f', justifyContent: 'center', alignItems: 'center',}}>
                            <i class="fa fa-check" style={{color: '#669e3f', fontSize: 30}}></i>
                        </div>
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 15, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{this.props.eventData.useEuro ? language.voucheradded : language.tokensadded}</p>
                    </div>
                    :null}
                    {this.state.process === 2 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.invalidlink}</p>
                    </div>
                    :null}
                    {this.state.process === 3 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.shareinsufbalance}</p>
                    </div>
                    :null}	
                    {this.state.process === 4 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.somethingwrong}</p>
                    </div>
                    :null}
                    {this.state.process === 5 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.sharesameuser}</p>
                    </div>
                    :null}
                    {this.state.process === 6 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 16, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.sharewrongevt}</p>
                    </div>
                    :null}
                    {this.state.process === 7 ?
                    <div style={{marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>		
                        <img src={Warning} style={{width: 130, height: 90}} />
                        <p style={{fontSize: 14, marginTop: 25, marginBottom: 30, color: '#22293b', fontFamily: 'Kentledge', paddingHorizontal: 25, textAlign: 'center'}}>{language.linkalreadyused}</p>
                    </div>
                    :null}
                </div>
            </div>


		</div>            
        )
    }

    state = {process: -1, voucher: ''}

    processSharecode = () => {
        this.setState(({process: 0}),() => {
            if(this.state.voucher !== '' && !this.proceslink && this.props.cardID){
                this.proceslink = true;
                var procesShareLink = functions.httpsCallable('procesShareLink');
                var processShareObj = {sharecode: this.state.voucher, oid: this.props.eventData.oid, eid: this.props.eventData.eventid, cardID: this.props.cardID};
                if(this.props.userData.id && this.props.userData.id != ''){processShareObj['uid'] = this.props.userData.id}
                if(this.props.eventData.paymentInfo && this.props.eventData.paymentInfo.name){processShareObj['name'] = this.props.eventData.paymentInfo.name}
                procesShareLink(processShareObj).then(result => {
                    this.setState({voucher: ''});
                    this.proceslink = false; 
                    this.setState({process: result.data.newState ? result.data.newState : result.data.state})
                }).catch(err => {console.log(err); this.proceslink = false});
            }
            else{
                this.setState({process: 4});
            }
        }, 500);
    }
    
}
    
export default Payment;